const popupsNames = {
  match: "match",
  personalRoom: "personalRoom",
  authorization: "authorization",
  newThread: "newThread",
  matchNotification: "matchNotification"
};

export default popupsNames;



// WEBPACK FOOTER //
// ./src/constants/popups.js